export const constants = {
  headerHeight: 98,
  headerHeightMobile: 70,
  dockedMenuHeight: 32,
  dockedStepperHeight: 56,
  dockedWarningHeight: 20,
  dockedAgentInfoHeight: 65,
  disableBannerHeight: 65,
  verticalPageOffset: 50
};

export const intimationConstants = {
  headerHeight: 138,
  headerHeightMobile: 110,
  dockedMenuHeight: 32,
  dockedStepperHeight: 56,
  dockedWarningHeight: 20,
  dockedAgentInfoHeight: 65,
  disableBannerHeight: 40,
  verticalPageOffset: 50
};

export const PENDING_STATUS = [
  "Pending Addition",
  "Pending Updates",
  "Pending Termination",
];